export default {"src":"/_next/static/media/KidneyDisease.b1986f0c.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};